import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <DefaultBusinessLayout
    key="/business/technologies/face-ai"
    exact
    path="/business/technologies/face-ai"
    component={AsyncPage}
    backgroundImage={require('../../../../assets/images/consumer/technologies/background.jpg')}
  />,
];
